export default "__VITE_ASSET__dchyPSZ$__"